import { api, getToken } from "./api";

const BASE = process.env.REACT_APP_API_URL;

async function postForm(path, fd) {
  const res = await fetch(`${BASE}/api${path}`, {
    method: "POST",
    headers: { Authorization: `Bearer ${getToken()}` },
    body: fd,
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(typeof data?.detail === "string" ? data.detail : `Request failed (${res.status})`);
  }
  return data;
}

export async function searchByImage(file) {
  const fd = new FormData();
  fd.append("file", file, file.name || "photo.jpg");
  return postForm("/search/image", fd);
}

export async function searchByVoice(blob) {
  const fd = new FormData();
  fd.append("audio", blob, "voice.webm");
  return postForm("/search/voice", fd);
}

export async function uploadImage(file, onStage) {
  const start = await api("/media/uploads", {
    method: "POST",
    auth: true,
    body: {
      kind: "image",
      filename: file.name || "photo",
      mime: file.type || "image/jpeg",
      size: file.size,
      purpose: "product",
    },
  });
  const { id, chunk_size, total_chunks } = start;
  for (let i = 0; i < total_chunks; i++) {
    onStage?.(`Uploading part ${i + 1}/${total_chunks}`);
    const fd = new FormData();
    fd.append("chunk", file.slice(i * chunk_size, (i + 1) * chunk_size), file.name || "chunk");
    const res = await fetch(`${BASE}/api/media/uploads/${id}/chunks/${i}`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${getToken()}` },
      body: fd,
    });
    if (!res.ok) {
      const d = await res.json().catch(() => null);
      throw new Error(typeof d?.detail === "string" ? d.detail : "Chunk upload failed");
    }
  }
  onStage?.("Processing photo...");
  return api(`/media/uploads/${id}/complete`, { method: "POST", auth: true });
}
